import { userAnnotationState } from "@/state/UserAnnotations";
import { submissionState } from "@/state/Submissions";
import { courseState } from "@/state/Courses";
import { exerciseState } from "@/state/Exercises";
import { userState } from "@/state/Users";
import { annotationState } from "@/state/Annotations";

export interface AnnotationContext {
    submissionId: number | undefined;
    courseId: number | undefined;
    exerciseId: number | undefined;
    userId: number | undefined;
    code: string;
    userIsStudent: boolean;
    canSubmitAsOwn: boolean;
}

/**
 * Primes the global annotation-related state singletons with submission/user/course
 * identity so downstream annotation UI (legacy code-listing rows and the new Lit
 * feedback code tab) can render consistently. Shared between both code paths to
 * prevent drift.
 */
export function setupAnnotationContext(ctx: AnnotationContext): void {
    userAnnotationState.reset();
    submissionState.code = ctx.code;
    submissionState.id = ctx.submissionId;
    courseState.id = ctx.courseId;
    exerciseState.id = ctx.exerciseId;
    userState.id = ctx.userId;
    annotationState.isQuestionMode = ctx.userIsStudent;

    if (ctx.canSubmitAsOwn) {
        userState.addPermission("submission.submit_as_own");
    }
}
